import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import { useAuth } from '../contexts/AuthContext';

const Navbar: React.FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  return (
    <nav className="bg-white border-b">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <img src={logo} alt="SR Patel Jewels" className="w-24 h-24 object-contain" />
          <div className="hidden sm:flex items-center space-x-6">
            <NavLink to="/customers" className={({isActive}) => `text-lg font-semibold ${isActive ? 'text-[#14532d]' : 'text-gray-700 hover:text-[#14532d]'}`}>Customer Details</NavLink>
            <NavLink to="/employees" className={({isActive}) => `text-lg font-semibold ${isActive ? 'text-[#14532d]' : 'text-gray-700 hover:text-[#14532d]'}`}>Employee Details</NavLink>
          </div>
        </div>
        <button onClick={() => { logout(); navigate('/login'); }} className="btn-primary">Logout</button>
      </div>
    </nav>
  );
};

export default Navbar;


